import { inputBorderRadiusMedium } from "src/styles/components/constants";

export const senecNativeSelectTheme = {
    styleOverrides: {
        select: {
            "&:focus": { borderRadius: `${inputBorderRadiusMedium} !important` },
            "&:focus-visible": { borderRadius: `${inputBorderRadiusMedium} !important` },
        },
    },
};
